import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import { isManager } from '../../utils/roleUtils';

const ManagerRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      if (user?.id) {
        try {
          const response = await api.get('/api/auth/role');
          setUserRole(response.data?.role);
        } catch (err) {
          console.error('Error checking user role:', err);
        } finally {
          setRoleLoading(false);
        }
      } else {
        setRoleLoading(false);
      }
    };

    checkRole();
  }, [user?.id]);

  if (loading || roleLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{
          from: location.pathname,
          message: "Session expired. Please log in."
        }}
        replace
      />
    );
  }

  if (!isManager(userRole)) {
    // Redirect non-managers to dashboard
    return (
      <Navigate
        to="/dashboard"
        state={{
          message: "Access denied. Manager role required."
        }}
        replace
      />
    );
  }

  return children;
};

export default ManagerRoute;

